// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","spin":"Loader_spin__1X-nh"};